module.exports = __webpack_public_path__ + "media/sign.f9a830c9.mp3";